import React from 'react'
import Tooltip from 'react-tooltip'
import cx from 'classnames'

import TextArea from 'components/form/TextArea/TextArea'

import s from './TextArea.scss'

import helpImage from './images/help.svg'


const ProfilePageTextArea = ({ className, valueLink, placeholder, type, label, help }) => (
  <div className={className}>
    {
      Boolean(help) && (
        <Tooltip className={s.tooltip} id={`tip${label}`} effect="solid" place="top">
          <div dangerouslySetInnerHTML={{ __html: help }}/>
        </Tooltip>
      )
    }
    <div className={s.label}>
      {label}
      {
        Boolean(help) && (
          <img
            className={s.help}
            src={helpImage}
            data-tip
            data-for={`tip${label}`}
          />
        )
      }
    </div>
    <div className={cx(s.inputWrapper, { [s.error]: Boolean(valueLink.error) })}>
      <TextArea {...{ valueLink, type, placeholder, placeholderClassName: s.placeholder }} />
    </div>
  </div>
)


export default ProfilePageTextArea
